var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-after-register"},[_c('p',[_vm._v(" Qual o seu principal interesse na plataforma? ")]),_c('big-buttons',{attrs:{"login":"","options":[
      {
        id: 'producer',
        name: 'Vender os meus produtos digitais',
        src: require("@/assets/images/auth-after-register/producer.svg")
      },
      {
        id: 'affiliate',
        name: 'Vender produtos e ganhar comissões',
        src: require("@/assets/images/auth-after-register/affiliate.svg")
      }
    ]},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_c('auth-button',{staticClass:"mt-2",attrs:{"text":"Entrar","loading":_vm.loading,"disabled":!_vm.selected || _vm.loading},on:{"click":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }